import React from 'react'

import {zIndex} from '../styles.js'

/** The git branch at the top of the screen in development (or with SHOW_BRANCH_BAR=true), above the top bar or the page next to the side nav */
export default function DevBranchBadge() {
    if ((process.env.NODE_ENV !== 'development' && process.env.SHOW_BRANCH_BAR !== 'true') || !process.env.CURRENT_BRANCH) {
        return null
    }

    return (
        <div style={{position: 'fixed', top: 8, left: '50%', transform: 'translateX(-50%)', zIndex: zIndex.nav + 1, padding: '4px 16px', backgroundColor: 'rgba(0, 255, 97, 0.5)', borderRadius: 8, fontSize: 12, color: 'darkgreen'}}>
            Branch: {process.env.CURRENT_BRANCH}
        </div>
    )
}
